import React from 'react';
import { TableRow, TableCell } from '@mui/material';

// Helper component for form rows with improved spacing - moved outside to prevent recreation on each render
const FormRow = ({ label, required, children, fullWidth = false, section = false }) => (
  <TableRow 
    sx={{ 
      '&:hover': { bgcolor: section ? 'transparent' : 'rgba(0, 0, 0, 0.02)' },
      '&:last-child td': { borderBottom: 0 }
    }}
  >
    <TableCell 
      sx={{ 
        width: '32%', 
        fontWeight: section ? 700 : (required ? 600 : 500),
        verticalAlign: 'top', 
        pt: section ? 3 : 2.5,
        pb: section ? 1.5 : 2.5,
        color: section ? 'primary.main' : 'text.primary',
        fontSize: section ? '0.95rem' : '0.875rem',
        borderBottom: section ? '2px solid' : '1px solid',
        borderColor: section ? 'primary.light' : 'divider',
        bgcolor: section ? 'rgba(25, 118, 210, 0.04)' : 'transparent'
      }}
    >
      {label}
      {required && !section && <span style={{ color: '#d32f2f', marginLeft: 6, fontWeight: 600 }}>*</span>}
    </TableCell>
    <TableCell 
      sx={{ 
        width: fullWidth ? '68%' : '34%', 
        pt: section ? 3 : 2.5, 
        pb: section ? 1.5 : 2.5,
        borderBottom: section ? '2px solid' : '1px solid',
        borderColor: section ? 'primary.light' : 'divider'
      }}
    >
      {children}
    </TableCell>
    {!fullWidth && <TableCell sx={{ width: '34%', borderBottom: section ? '2px solid' : '1px solid', borderColor: section ? 'primary.light' : 'divider' }} />}
  </TableRow>
);

export default FormRow;

